/* FACEPLANT slide-out cart drawer.
   Keeps shoppers on the brand pages instead of the stock /cart template.
   Every price shown is read from /cart.js, so it is what Shopify will charge. */
(function () {
  if (window.__fpCart) return;
  window.__fpCart = true;

  var ACCENT = '#4FC23A', DEEP = '#3A9429', INK = '#121410', BONE = '#F6F5F1',
      BORDER = '#E3E2DC', MUTED = '#5A5E54';
  var BASE = (window.FP_ASSETS || '/cdn/shop/t/2/assets/');
  var LOGO = BASE + 'fp-logo-v2.webp';
  var PROTECT_HANDLE = 'shipping-protection';
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };

  // the product has no media in Shopify yet, so fall back to the colourway art
  var POT = { green: 'fp-green.webp', yellow: 'fp-yellow.webp', pink: 'fp-pink.webp', purple: 'fp-purple.webp' };
  function itemImage(it) {
    // Colourway first: the product's featured image is one colour, so a line
    // item's it.image is wrong for every variant except that one. Only fall
    // back to it.image when the option value is not a colourway we know.
    var v = ((it.options_with_values || [])[0] || {}).value || '';
    var f = POT[v.toLowerCase()];
    if (f) return BASE + f;
    if (it.image) return it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
    return '';
  }

  var css = document.createElement('style');
  css.textContent = [
    '.fpc-scrim{position:fixed;inset:0;background:rgba(18,20,16,.42);opacity:0;pointer-events:none;transition:opacity 220ms ease-out;z-index:9998}',
    '.fpc-scrim.on{opacity:1;pointer-events:auto}',
    '.fpc{position:fixed;top:0;right:0;height:100%;width:min(430px,100vw);background:' + BONE + ';transform:translateX(100%);transition:transform 260ms cubic-bezier(.2,.8,.2,1);z-index:9999;display:flex;flex-direction:column;font-family:inherit}',
    '.fpc.on{transform:none}',
    '.fpc-hd{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid ' + BORDER + '}',
    '.fpc-logo{height:32px;width:auto;display:block}',
    '.fpc-x{border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:' + MUTED + ';padding:0 4px}',
    '.fpc-body{flex:1;overflow-y:auto;padding:16px 22px 10px}',
    '.fpc-item{display:grid;grid-template-columns:84px 1fr;gap:14px;padding:14px 0;border-bottom:1px solid ' + BORDER + '}',
    '.fpc-thumb{width:84px;height:84px;border-radius:16px;background:#fff;border:1px solid ' + BORDER + ';display:flex;align-items:center;justify-content:center;overflow:hidden}',
    '.fpc-thumb img{width:100%;height:100%;object-fit:contain;display:block}',
    '.fpc-t{font-size:15px;font-weight:700;color:' + INK + ';margin:0}',
    '.fpc-v{font-size:13px;color:' + MUTED + ';margin:2px 0 6px}',
    '.fpc-unit{font-size:13px;margin:0 0 8px;color:' + MUTED + '}',
    '.fpc-unit s{color:#9BA093;margin-right:6px}',
    '.fpc-unit b{color:' + DEEP + '}',
    '.fpc-row{display:flex;align-items:center;justify-content:space-between;gap:10px}',
    '.fpc-qty{display:inline-flex;align-items:center;border:1px solid ' + BORDER + ';border-radius:999px;background:#fff;overflow:hidden}',
    '.fpc-qty button{border:0;background:none;width:30px;height:30px;font-size:16px;cursor:pointer;color:' + INK + '}',
    '.fpc-qty span{min-width:22px;text-align:center;font-size:14px;font-weight:600}',
    '.fpc-price{font-size:16px;font-weight:700;color:' + INK + '}',
    '.fpc-rm{border:0;background:none;color:' + MUTED + ';font-size:12px;cursor:pointer;text-decoration:underline;padding:0;margin-top:8px}',
    '.fpc-save{display:flex;align-items:center;gap:8px;background:#EAF7E6;border-radius:14px;padding:10px 14px;margin-top:14px;font-size:13px;font-weight:700;color:' + DEEP + '}',
    '.fpc-nudge{margin-top:14px;background:#fff;border:1px solid ' + BORDER + ';border-radius:18px;padding:14px 16px;display:grid;grid-template-columns:58px 1fr;gap:14px;align-items:center}',
    '.fpc-nudge img{width:58px;height:58px;object-fit:contain;display:block}',
    '.fpc-nudge b{display:block;font-size:14px;color:' + INK + '}',
    '.fpc-nudge p{margin:2px 0 8px;font-size:13px;color:' + MUTED + '}',
    '.fpc-nudge button{border:0;background:' + ACCENT + ';color:' + INK + ';font-weight:700;font-size:13px;padding:8px 16px;border-radius:999px;cursor:pointer}',
    '.fpc-prot{display:flex;gap:12px;align-items:flex-start;background:#fff;border:1px solid ' + BORDER + ';border-radius:18px;padding:14px 16px;margin-top:12px;cursor:pointer}',
    '.fpc-prot--free{cursor:default;background:#F2FBEF;border-color:#CFE9C6}',
    '.fpc-prot--free svg{flex:0 0 auto;width:20px;height:20px;margin-top:1px;color:' + DEEP + '}',
    '.fpc-prot input{margin-top:3px;width:18px;height:18px;accent-color:' + ACCENT + ';cursor:pointer;flex:0 0 auto}',
    '.fpc-prot b{display:block;font-size:14px;color:' + INK + '}',
    '.fpc-prot p{margin:2px 0 0;font-size:12.5px;color:' + MUTED + ';line-height:1.45}',
    '.fpc-ft{border-top:1px solid ' + BORDER + ';padding:16px 22px 20px;background:' + BONE + '}',
    '.fpc-sub{display:flex;justify-content:space-between;align-items:baseline}',
    '.fpc-sub span:first-child{font-size:15px;color:' + INK + '}',
    '.fpc-sub span:last-child{font-size:22px;font-weight:800;color:' + INK + '}',
    '.fpc-note{font-size:12px;color:' + MUTED + ';margin:2px 0 12px}',
    '.fpc .fp-pay{display:flex;flex-direction:column;align-items:center;gap:7px;margin-top:12px}',
    '.fpc .fp-pay > span{font-size:11.5px;font-weight:600;color:' + MUTED + '}',
    '.fpc .fp-pay-row{display:flex;flex-wrap:wrap;justify-content:center;gap:6px}',
    '.fpc .fp-pay-row svg{width:38px;height:24px;border:1px solid ' + BORDER + ';border-radius:4px;display:block}',
    '.fpc-sign{font-size:11.5px;color:' + MUTED + ';text-align:center;margin:10px 0 0;font-style:italic}',
    '.fpc-go{display:block;width:100%;text-align:center;background:' + ACCENT + ';color:' + INK + ';font-weight:800;font-size:16px;padding:15px;border:0;border-radius:999px;cursor:pointer;text-decoration:none}',
    '.fpc-trust{display:flex;flex-wrap:nowrap;gap:4px;justify-content:space-between;align-items:flex-start;margin:0 0 14px;padding:12px 0;border-top:1px solid ' + BORDER + ';border-bottom:1px solid ' + BORDER + '}',
    '.fpc-trust span{flex:1 1 0;min-width:0;display:flex;flex-direction:column;align-items:center;gap:6px;text-align:center;font-size:12px;line-height:1.25;font-weight:700;color:' + INK + '}',
    '.fpc-trust svg{flex:none}',
    '@media (max-width:360px){.fpc-trust span{font-size:10px}}',
    '.fpc-empty{text-align:center;padding:56px 10px;color:' + MUTED + '}',
    '.fpc-empty a{display:inline-block;margin-top:14px;background:' + ACCENT + ';color:' + INK + ';font-weight:700;padding:12px 22px;border-radius:999px;text-decoration:none}',
    '@media (prefers-reduced-motion:reduce){.fpc,.fpc-scrim{transition:none}}'
  ].join('');
  document.head.appendChild(css);

  var tick = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="' + DEEP + '" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function ico(d, fill) {
    return '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="' + d + '" stroke="' + (fill || DEEP) + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  var icoShip = ico('M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 100-4 2 2 0 000 4zM18 19a2 2 0 100-4 2 2 0 000 4z');
  var icoReturn = ico('M3 10h11a5 5 0 010 10h-3M3 10l4-4M3 10l4 4');
  var icoLock = ico('M6 11h12v9H6zM9 11V8a3 3 0 016 0v3');
  var icoShield = ico('M12 3l7 3v6c0 4-3 6.5-7 9-4-2.5-7-5-7-9V6z');

  var scrim = document.createElement('div'); scrim.className = 'fpc-scrim';
  var el = document.createElement('aside');
  el.className = 'fpc'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-label', 'Cart');
  el.innerHTML =
    '<div class="fpc-hd"><img class="fpc-logo" src="' + LOGO + '" alt="FACEPLANT"><button class="fpc-x" aria-label="Close">&times;</button></div>' +
    '<div class="fpc-body"></div><div class="fpc-ft"></div>';
  function mount() { if (!el.parentNode && document.body) { document.body.appendChild(scrim); document.body.appendChild(el); } }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);

  var body = el.querySelector('.fpc-body'), foot = el.querySelector('.fpc-ft');
  /* Protection is included free now, so there is no product to look up. The old
     lookup 404'd on every cart open because `shipping-protection` does not exist. */
  var protectVariant = null, protectPrice = 0;

  function open() { mount(); scrim.classList.add('on'); el.classList.add('on'); document.body.style.overflow = 'hidden'; render(); }
  function close() { scrim.classList.remove('on'); el.classList.remove('on'); document.body.style.overflow = ''; }
  scrim.addEventListener('click', close);
  el.querySelector('.fpc-x').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function api(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json(); });
  }
  function change(key, qty) { return api('/cart/change.js', { id: key, quantity: qty }).then(function () { render(); bumpCount(); }); }
  function bumpCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('a[href="/cart"] span').forEach(function (s) {
        if (/^\s*\d+\s*$/.test(s.textContent)) s.textContent = c.item_count;
      });
    });
  }

  function render() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var pots = cart.items.filter(function (i) { return i.handle !== PROTECT_HANDLE; });
      var prot = cart.items.filter(function (i) { return i.handle === PROTECT_HANDLE; })[0];

      if (!pots.length) {
        body.innerHTML = '<div class="fpc-empty"><p>Empty. Not even a bit of soil.</p><a href="/products/faceplant">Meet the pot</a></div>';
        foot.innerHTML = ''; return;
      }

      var potQty = pots.reduce(function (a, i) { return a + i.quantity; }, 0);

      body.innerHTML = pots.map(function (it) {
        var img = itemImage(it);
        var opt = (it.options_with_values || []).map(function (o) { return o.value; }).join(' / ');
        var lineNet = it.final_line_price - (it.total_discount || 0);
        var unitNet = it.quantity ? Math.round(lineNet / it.quantity) : it.final_price;
        var unitLine = unitNet < it.original_price
          ? '<p class="fpc-unit"><s>' + money(it.original_price) + '</s><b>' + money(unitNet) + ' each</b></p>'
          : '<p class="fpc-unit">' + money(unitNet) + ' each</p>';
        return '<div class="fpc-item" data-key="' + it.key + '">' +
          '<div class="fpc-thumb">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
          '<div><p class="fpc-t">' + it.product_title + '</p>' +
          (opt ? '<p class="fpc-v">' + opt + '</p>' : '') + unitLine +
          '<div class="fpc-row"><div class="fpc-qty">' +
          '<button data-act="dec" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span>' +
          '<button data-act="inc" aria-label="Increase">+</button></div>' +
          '<span class="fpc-price">' + money(lineNet) + '</span></div>' +
          '<button class="fpc-rm" data-act="rm">Rehome</button></div></div>';
      }).join('');

      if (cart.total_discount > 0) {
        body.insertAdjacentHTML('beforeend',
          '<div class="fpc-save">' + tick + 'Nice. You kept ' + money(cart.total_discount) + '</div>');
      }

      var nudge = null;
      if (potQty === 1) nudge = ['Send one to a friend', 'Drops both to $89 each. Especially good for the friend whose plants never quite make it.', 'fp-yellow.webp'];
      else if (potQty === 2) nudge = ['Three makes it a collection', '$83 each, and a fourth drops it to $79.', 'fp-pink.webp'];
      if (nudge) {
        body.insertAdjacentHTML('beforeend',
          '<div class="fpc-nudge"><img src="' + BASE + nudge[2] + '" alt="">' +
          '<div><b>' + nudge[0] + '</b><p>' + nudge[1] + '</p>' +
          '<button data-act="bundle">Add one</button></div></div>');
      }

      body.insertAdjacentHTML('beforeend',
        '<div class="fpc-prot fpc-prot--free">' + icoShield +
        '<span><b>Shipping protection included</b>' +
        '<p>Lost, stolen or damaged on the way? We reship it or refund you. No claim forms, no extra cost.</p></span></div>');

      foot.innerHTML =
        '<div class="fpc-trust">' +
          '<span>' + icoShip + 'Free shipping</span>' +
          '<span>' + icoReturn + '30-day returns</span>' +
          '<span>' + icoShield + 'Free protection</span>' +
          '<span>' + icoLock + 'Secure checkout</span>' +
        '</div>' +
        '<div class="fpc-sub"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="fpc-note">Shipping is on us. Tax worked out at checkout.</p>' +
        '<a class="fpc-go" href="/checkout">Checkout</a>' +
        '<div class="fp-pay"><span>Secure checkout</span><div class="fp-pay-row"><svg viewBox="0 0 48 30" aria-label="Visa"><rect width="48" height="30" rx="5" fill="#1A1F71"/><text x="24" y="20" text-anchor="middle" fill="#fff" font-family="Outfit,sans-serif" font-size="12" font-weight="800" letter-spacing="0.5">VISA</text></svg><svg viewBox="0 0 48 30" aria-label="Mastercard"><rect width="48" height="30" rx="5" fill="#F4F4F2"/><circle cx="20" cy="15" r="8" fill="#EB001B"/><circle cx="28" cy="15" r="8" fill="#F79E1B" fill-opacity="0.9"/></svg><svg viewBox="0 0 48 30" aria-label="American Express"><rect width="48" height="30" rx="5" fill="#1F72CD"/><text x="24" y="19" text-anchor="middle" fill="#fff" font-family="Outfit,sans-serif" font-size="9.5" font-weight="800">AMEX</text></svg><svg viewBox="0 0 48 30" aria-label="Discover"><rect width="48" height="30" rx="5" fill="#F4F4F2"/><text x="20" y="19" text-anchor="middle" fill="#231F20" font-family="Outfit,sans-serif" font-size="8" font-weight="700">DISC</text><circle cx="37" cy="15" r="6" fill="#F76E11"/></svg><svg viewBox="0 0 48 30" aria-label="PayPal"><rect width="48" height="30" rx="5" fill="#F4F4F2"/><text x="24" y="20" text-anchor="middle" fill="#003087" font-family="Outfit,sans-serif" font-size="11" font-weight="800">PayPal</text></svg><svg viewBox="0 0 48 30" aria-label="Apple Pay"><rect width="48" height="30" rx="5" fill="#000"/><text x="24" y="20" text-anchor="middle" fill="#fff" font-family="Outfit,sans-serif" font-size="11" font-weight="600">&#63743;Pay</text></svg><svg viewBox="0 0 48 30" aria-label="Google Pay"><rect width="48" height="30" rx="5" fill="#F4F4F2"/><text x="24" y="20" text-anchor="middle" fill="#5F6368" font-family="Outfit,sans-serif" font-size="11" font-weight="700">G Pay</text></svg><svg viewBox="0 0 48 30" aria-label="Shop Pay"><rect width="48" height="30" rx="5" fill="#5A31F4"/><text x="24" y="20" text-anchor="middle" fill="#fff" font-family="Outfit,sans-serif" font-size="11" font-weight="700">shop</text></svg></div></div>' +
        '<p class="fpc-sign">It is already deciding what face to pull.</p>';
    });
  }

  body.addEventListener('change', function (e) {
    var c = e.target.closest('input[data-act="protect"]'); if (!c || !protectVariant) return;
    if (c.checked) { api('/cart/add.js', { id: protectVariant, quantity: 1 }).then(function () { render(); bumpCount(); }); }
    else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var p = cart.items.filter(function (i) { return i.handle === PROTECT_HANDLE; })[0];
        if (p) change(p.key, 0);
      });
    }
  });

  body.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var act = b.getAttribute('data-act');
    if (act === 'bundle') {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var it = c.items.filter(function (i) { return i.handle !== PROTECT_HANDLE; })[0];
        if (it) api('/cart/add.js', { id: it.variant_id, quantity: 1 }).then(function () { render(); bumpCount(); });
      });
      return;
    }
    var wrap = b.closest('.fpc-item'); if (!wrap) return;
    var key = wrap.getAttribute('data-key');
    var cur = parseInt(wrap.querySelector('.fpc-qty span').textContent, 10);
    if (act === 'inc') change(key, cur + 1);
    if (act === 'dec') change(key, Math.max(0, cur - 1));
    if (act === 'rm') change(key, 0);
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"]');
    if (a) { e.preventDefault(); open(); }
  }, true);

  var of = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    if (url.indexOf('/cart/add') > -1) p.then(function () { setTimeout(open, 120); });
    return p;
  };
})();
